enum ModalToOpen {
	DuplicateCatalogDialog = "DuplicateCatalogDialog",
	DuplicateArticleDialog = "DuplicateArticleDialog",
	ReformatCatalogConfirm = "ReformatCatalogConfirm",
	ReformatCatalogReport = "ReformatCatalogReport",
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	OtherStorageHandler = "OtherStorageHandler",
	Clone = "Clone",
	PullHandler = "PullHandler",

	ImportModal = "ImportModal",

	FragmentAlreadyUseWarn = "FragmentAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	BpmnEditor = "BpmnEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	CreateStorage = "CreateStorage",

	EnterpriseLogout = "EnterpriseLogout",
	RepositoryPermission = "RepositoryPermission",

	TemplateContentWarning = "TemplateContentWarning",
	PropertySettings = "PropertySettings",

	CloudModal = "CloudModal",

	CreateWorkspaceForm = "CreateWorkspaceForm",

	MediaPreview = "MediaPreview",
	FilePreview = "FilePreview",

	// Article dropdown modals
	ItemPropsEditor = "ItemPropsEditor",
	MarkdownEditor = "MarkdownEditor",
	BugsnagModal = "BugsnagModal",
	UnsupportedElements = "UnsupportedElements",
	Share = "Share",
	NotificationSettings = "NotificationSettings",

	// Catalog dropdown modals
	Healthcheck = "Healthcheck",

	ActionConfirm = "ActionConfirm",

	ExportPdf = "ExportPdf",

	GesAdmin = "GesAdmin",

	DefaultModal = "DefaultModal",
	UnsavedChangesModal = "UnsavedChangesModal",

	TauriGesSignIn = "TauriGesSignIn",

	CreateAccessToken = "CreateAccessToken",
	ShowAccessToken = "ShowAccessToken",

	GesCloudInitCatalog = "GesCloudInitCatalog",
	GesCloudSignIn = "GesCloudSignIn",
	TariffChoose = "TariffChoose",
	GesCloudPurchaseSeatPayModal = "GesCloudPurchaseSeatPayModal",
	GesCloudPayerTypeChoose = "GesCloudPayerTypeChoose",
	GesCloudChangePeriod = "GesCloudChangePeriod",
	GesCloudLegalEntitySwitch = "GesCloudLegalEntitySwitch",
	GesCloudInviteMismatch = "GesCloudInviteMismatch",
	GesCloudOrganizationAccessDenied = "GesCloudOrganizationAccessDenied",
	GesCloudOrganizationSettings = "GesCloudOrganizationSettings",
	GesCloudSignOut = "GesCloudSignOut",
	GesAppSettings = "GesAppSettings",
	GesCloudRecoverPaymentInfo = "GesCloudRecoverPaymentInfo",
	CancelSubscription = "CancelSubscription",
	GesCloudRepositoryPermission = "GesCloudRepositoryPermission",

	AlertConfirm = "AlertConfirm",
	LfsMigration = "LfsMigration",
	LfsAutoAttachments = "LfsAutoAttachments",

	AppSettings = "AppSettings",
	AgentContextUsageModal = "AgentContextUsageModal",
}

export default ModalToOpen;
